import { render, staticRenderFns } from "./PaginatedList.vue?vue&type=template&id=384a99d4&scoped=true&"
import script from "./PaginatedList.vue?vue&type=script&lang=js&"
export * from "./PaginatedList.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedList.vue?vue&type=style&index=0&id=384a99d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384a99d4",
  null
  
)

export default component.exports